import { useNavigate } from "react-router-dom";
import "./Landing.css";

const FEATURES = [
  { icon: "☀️", label: "Daily focus",     desc: "See what matters today at a glance." },
  { icon: "📋", label: "Smart planner",   desc: "Tasks, reminders, and payments in one place." },
  { icon: "💰", label: "Finance tracker", desc: "Accounts, transactions, budgets, and investments." },
  { icon: "📝", label: "Rich notes",      desc: "Write, link, and search everything you know." },
  { icon: "🔄", label: "Habit tracking",  desc: "Build consistency with daily habit streaks." },
  { icon: "📊", label: "Weekly review",   desc: "Reflect and plan ahead every week." },
];

export default function Landing() {
  const nav = useNavigate();

  return (
    <div className="landing-page">
      <div className="landing-container">
        <div className="landing-hero">
          <div className="landing-brand">
            <div className="landing-brand-icon">L</div>
            <span className="landing-brand-name">LifeOS</span>
          </div>
          <h1 className="landing-headline">Your life, organized.</h1>
          <p className="landing-sub">
            One app for your tasks, finances, notes, habits, and everything in between.
          </p>
          <div className="landing-actions">
            <button className="btn btn-primary landing-btn-primary" onClick={() => nav("/login")}>
              Sign in
            </button>
            <button className="btn landing-btn-secondary" onClick={() => nav("/signup")}>
              Create account
            </button>
          </div>
        </div>

        <div className="landing-features">
          {FEATURES.map(({ icon, label, desc }) => (
            <div key={label} className="landing-feature">
              <span className="landing-feature-icon">{icon}</span>
              <div>
                <div className="landing-feature-label">{label}</div>
                <div className="landing-feature-desc">{desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
